// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 143 ? "app" : chunkId) + "." + {"143":"6fad086b3712da5a2a3e","871":"e58fa9ea2b7989d7691a"}[chunkId] + ".css";
};